<template>
  <a-row type="flex" justify="center" align="middle" style="min-height: 100vh">
    <a-col :sm="20" :md="14" :lg="10">
      <a-row type="flex" justify="center" align="middle">
        <img src="@/assets/images/token-expired.svg" style="height: 300px" />
      </a-row>
      <a-typography-title
        :level="2"
        style="bottom: 0px; font-family: 'Urbanist'; text-align: center"
      >
        Este formulario ya no está disponible
      </a-typography-title>
      <a-alert v-if="reason" type="info" show-icon :message="reason" />
    </a-col>
  </a-row>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

// Why the form is closed, from the ticket state the landing found.
const REASON_BY_STATE = {
  3: 'La información ya fue procesada por la aseguradora.',
  4: 'La solicitud fue cancelada.',
  7: 'La información ya fue enviada a la corredora de seguros.',
  8: 'La información ya fue enviada a la aseguradora.'
};

const route = useRoute();
const reason = computed(() => REASON_BY_STATE[route.query.state] || null);
</script>
